module.exports = require('./helpers/bundle-url').getBundleURL('6D0M9') + "logo.c51670a8.svg";